var _image;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconInfo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "27px",
    height: "27px",
    viewBox: "0 0 27 27",
    enableBackground: "new 0 0 27 27",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _image || (_image = /*#__PURE__*/React.createElement("image", {
    id: "image0",
    width: 27,
    height: 27,
    x: 0,
    y: 0,
    href: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABsAAAAbCAAAAACov6uJAAAABGdBTUEAALGPC/xhBQAAACBjSFJN AAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAAmJLR0QA/4ePzL8AAAAJcEhZ cwAAAGAAAABgAPBrQs8AAAAHdElNRQfmBQIFNDNsEUXOAAABXklEQVQoz3WSvU7CUBiGD8eYmAhJ DQgBhuqKkyJegQlIxBtwBeUGJMSlEC/Cn9ERkERcNI4OJvzpIiSu2haS2hKBGAb6OpT2FALv9L3f c/5yvtcBYmj4VGmJiicYSsRWJy0CAEAvy0Uvq+JIrF3FuKxmNA1250uJMCWe+EoW0/N8HXY1+Zw+ YflIB9PqRASDlflZBHQ3igBBz8cO/NHN6s2rgeA8aaHqzq1VpzMggzX2wq/kq1VLXJ+Uo5iveHFp ZX+XWGo7l616+EzbYYb0409mwi0qBpgdE52ZgEyVdWZhZ26FupUF+1Q3DUq2++xM9tNQfQGrbdHE /QJWOSR9jv2Ltv1i+5df6kznyDxdpFwEmrdhrh1//7E5qCBAae78CsbchUh3Fu0JZl4EvjmF3jcF My9A0XsqWUROewu2DELNcAfXDWkkNW7i3JlqNB1mrgePDx+y4vGHjqKuSesfkQuoMKE6BXMAAAAl dEVYdGRhdGU6Y3JlYXRlADIwMjItMDUtMDJUMDU6NTI6NTErMDA6MDAd/M0XAAAAJXRFWHRkYXRl Om1vZGlmeQAyMDIyLTA1LTAyVDA1OjUyOjUxKzAwOjAwbKF1qwAAAABJRU5ErkJggg=="
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInfo);
export default __webpack_public_path__ + "static/media/icon_info.c8b81c34.svg";
export { ForwardRef as ReactComponent };